import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import SaveIcon from '@mui/icons-material/Save';
// import Typography from '@mui/material/Typography';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
// import {renderCheckbox} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import {
//   FormControl,
//   FormGroup,
// } from '@mui/material';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_PROGRESS_BLOCK_LIST.name, href: ''},
];

// 調査・点検結果報告の場合、パンくずリストの表示内容
const transitionListReport = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_PROGRESS_BLOCK_REPORT_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const kenViews = [
  {binding: 'nwJigyosyo', header: '旧NW事業所', dataType: 'String', width: 90, readOnly: true},
  {binding: 'tskkJgyosyo', header: '調査機関事業所', dataType: 'String', width: 85, readOnly: true},
  {binding: 'blockNo', header: 'ブロック番号', dataType: 'CellMaker', width: 75, readOnly: true},
  {binding: 'daihyoZyusyo', header: '代表住所', dataType: 'String', width: 150, readOnly: true},
  {header: '調査（件）', dataType: 'header', elems: [
    {binding: 'tsKasyo', header: '調査箇所', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus10', header: '未着手', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus20', header: '調査中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus30', header: '調査済', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus40', header: '報告中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus60', header: '承認中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus90', header: '完了', dataType: 'Number', width: 61, readOnly: true},
    // {binding: 'tsReTs', header: '再調査', dataType: 'Number', width: 75, readOnly: true},
  ]},
  {header: '再調査（件）', dataType: 'header', elems: [
    {binding: 'tsReTs', header: '再調査', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tsStatus90Re', header: '完了', dataType: 'Number', width: 61, readOnly: true},

  ]},
  {header: '点検（件）', dataType: 'header', elems: [
    {binding: 'tkKasyo', header: '点検箇所', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus10', header: '未着手', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus20', header: '点検中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus30', header: '点検済', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus40', header: '報告中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus50', header: '確認中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus60', header: '承認中', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkStatus90', header: '完了', dataType: 'Number', width: 61, readOnly: true},
    {binding: 'tkFuryo', header: '不良等有', dataType: 'Number', width: 61, readOnly: true},

  ]},

];
const exceptFiltersBindings = [
  'tsKasyo', 'tsStatus10', 'tsStatus20', 'tsStatus30', 'tsStatus40', 'tsReTs', 'tsStatus90', 'tsStatus90Re', 'tsStatus60',
  'tkKasyo', 'tkStatus10', 'tkStatus20', 'tkStatus30', 'tkStatus40', 'tkStatus50', 'tkFuryo', 'tkStatus60', 'tkStatus90',
];

/**
 * 調査・点検進捗状況照会(ブロック別)画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    const title = props.title;
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
      title: title,
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
      let headerData = {zigyoujo: '', surveyYear: ''};
      headerData['zigyoujo'] = '5160';
      headerData['surveyYear'] = '1';
      this.props.doSetInitValues(headerData);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataKen =[
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10001', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '9,999', tsStatus10: '9,999', tsStatus20: '9,999', tsStatus30: '9,999', tsStatus40: '9,999', tsStatus90: '9,999', tsReTs: '9,999', tsStatus90Re: '9,999', tkKasyo: '9,999', tkStatus10: '9,999', tkStatus20: '9,999', tkStatus30: '9,999', tkStatus40: '9,999', tkStatus50: '9,999', tkStatus60: '9,999', tkStatus90: '9,999', tkFuryo: '9,999', tsSmFlag30: '1', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0', tsStatus60: '9,999'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10002', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '1', tkSmFlag40: '1', tkSmFlag50: '1'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10003', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '1', tkSmFlag30: '0', tkSmFlag40: '0', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10004', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10005', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '1', tkSmFlag40: '1', tkSmFlag50: '1'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10006', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '1', tkSmFlag30: '1', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10007', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '1'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10008', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '1', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '10009', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '100010', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '100011', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '0', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},
      {nwJigyosyo: '広島', tskkJgyosyo: '広島支', blockNo: '100012', daihyoZyusyo: '住所XXXXXXXXXX', tsKasyo: '100', tsStatus10: '10', tsStatus20: '20', tsStatus30: '30', tsStatus40: '20', tsStatus90: '20', tsReTs: '3', tsStatus90Re: '1', tkKasyo: '120', tkStatus10: '20', tkStatus20: '20', tkStatus30: '30', tkStatus40: '10', tkStatus50: '10', tkStatus60: '10', tkStatus90: '30', tkFuryo: '5', tsSmFlag30: '1', tkSmFlag30: '0', tkSmFlag40: '1', tkSmFlag50: '0'},

    ];

    this.gridRef.current.setItemsSource(dataKen);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
 * 承認状況画面を閉じる
 */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };
  /**
   * 否認画面の表示
   */
  displayApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: true,
    });
  };

  /**
 * 否認画面を閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['報告'],
      },
    });
  };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確認'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    if (view.dataType === 'CellMaker') {
      if (view.binding === 'blockNo') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.doEditLink(ctx.item.blockNo, ctx.item.blockNo);
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      } else if (view.binding === 'sinnseiStatus') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.displayApproval();
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      }
    }

    if (view.binding === 'blockNo') {
      return <FlexGridColumnGroup
        binding={view.binding}
        header={view.header}
        dataType='String'
        width={view.width}
        cellTemplate= {CellMaker.makeLink({
        // cssClass: 'bf-btn-navy',
          click: (e, ctx) => {
            this.doEditLink(ctx.item.blockNo, ctx.item.blockNo);
          },
          attributes: {
            tabindex: -1,
          },
        })}/>;
    }

    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}
      align={view.align}
      cssClass={view.cssClass}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
  // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }

    if (e.panel.cellType == CellType.Cell) {
      // e.cell.sytle.cssClass ='';
      // e.cell.sytle.cssClass ='oken-cell-font-red';
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;

      // 報告済みに、差戻がある場合、文字色は赤に設定する。（調査）
      if (col.binding === 'tsStatus30' && data.tsSmFlag30 === '1') {
        e.cell.innerHTML = '<div style="color:red">'+data.tsStatus30+'</div>';
      }

      if (col.binding === 'tkStatus30' && data.tkSmFlag30 === '1') {
        e.cell.innerHTML = '<div style="color:red">'+data.tkStatus30+'</div>';
      }

      if (col.binding === 'tkStatus40' && data.tkSmFlag40 === '1') {
        e.cell.innerHTML = '<div style="color:red">'+data.tkStatus40+'</div>';
      }

      if (col.binding === 'tkStatus50' && data.tkSmFlag50 === '1') {
        e.cell.innerHTML = '<div style="color:red">'+data.tkStatus50+'</div>';
      }
    }
  };

  /**
   * 県一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: true,
      exceptFilters: exceptFiltersBindings,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      frozenColumns: 3,
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
      // formatItemFunction: this.formatItemFunction,
    };

    let viewElems = [];
    if (kenViews) {
      for (const view of kenViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 一覧リンククリック時
   * @param {*} tskkJgyosyo 調査機関事業所
   * @param {*} sinnseiStatus ステータス
   */
  doEditLink = async (tskkJgyosyo, sinnseiStatus) => {
    try {
      let params = {
        tskkJgyosyo,
        mod: 'C',
      };

      // 調査・点検箇所一覧画面に遷移
      setSessionObject(GMN.TSTK_KASYO_LIST.id, params);
      this.props.navigate(GMN_PATH.TSTK_KASYO_LIST);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={5170}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'0000'}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >

          <Grid key="blockNo" item xs={12} sm={4}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
            <span className="wave">～</span>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
          <Grid key="tdhknAddCd" item xs={12} sm={5} >
            <Field
              id="tdhknAddCd"
              name="tdhknAddCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="都道府県"
              type="text"
              sx={{width: '20%'}}
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={31}>{'鳥取県'}</MenuItem>
              <MenuItem value={32}>{'島根県'}</MenuItem>
              <MenuItem value={33}>{'岡山県'}</MenuItem>
              <MenuItem value={34}>{'広島県'}</MenuItem>
              <MenuItem value={35}>{'山口県'}</MenuItem>
            </Field>
            <Field
              id="azatmApart"
              name="azatmApart"
              // variant="standard"
              component={renderTextField}
              // className="fields"
              label="住所"
              sx={{width: '75%'}}
              type="text"
              required={false}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >

          {this.state.title !== transitionListReport[1].gmnName &&
          <Grid key="reportStatus" item xs={12} sm={2}>
            <Field
              id="reportStatus"
              name="reportStatus"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="報告状況"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'未完了あり'}</MenuItem>
              <MenuItem value={2}>{'全完了のみ'}</MenuItem>
            </Field>
          </Grid>
          }
          {this.state.title !== transitionListReport[1].gmnName &&
          <Grid key="reportDate" item xs={12} sm={4}>
            <Field
              id="reportDateFrom"
              name="reportDateFrom"
              // accessibilitylabel={option.id + 'From'}
              label="調査・点検年月日"
              component={renderTextField}
              className="fields"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              // validate={[
              //   validateRule.date,
              //   validateRule.correctFromDate(values ? values[option.id + 'To'] : null),
              // ]}
            />
            <span className="wave">～</span>
            <Field
              id="reportDateTo"
              name="reportDateTo"
              // accessibilitylabel={option.id + 'To'}
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              // validate={[
              //   validateRule.date,
              //   validateRule.correctDate(values ? values[option.id + 'From'] : null),
              // ]}
            />
          </Grid>
          }
          {this.state.title == transitionListReport[1].gmnName &&
          <Grid key="tenKenFuryo" item xs={12} sm={2}>
            <Field
              id="tenKenFuryo"
              name="tenKenFuryo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="点検不良"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'不良あり'}</MenuItem>
              <MenuItem value={2}>{'不良なし'}</MenuItem>

            </Field>
          </Grid>
          }
          {this.state.title == transitionListReport[1].gmnName &&
          <Grid key="tyousaRyouCd" item xs={12} sm={2}>
            <Field
              id="tyousaRyouCd"
              name="tyousaRyouCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査良否区分"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'良'}</MenuItem>
              <MenuItem value={2}>{'不良'}</MenuItem>
              <MenuItem value={3}>{'不能'}</MenuItem>

            </Field>
          </Grid>
          }
          {this.state.title == transitionListReport[1].gmnName &&
          <Grid key="smdsZtiKbn" item xs={12} sm={2}>
            <Field
              id="smdsZtiKbn"
              name="smdsZtiKbn"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="否決"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'否決あり'}</MenuItem>
              <MenuItem value={2}>{'否決なし'}</MenuItem>

            </Field>
          </Grid>
          }
        </Grid>
        {this.state.title === transitionListReport[1].gmnName &&
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="tsStatus" item xs={12} sm={3}>
            <Field
              id="tsStatus"
              name="tsStatus"
              // variant="standard"
              component={renderSelectMultiLine}
              className="fields"
              label="調査・点検ステータス"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'未着手'}</MenuItem>
              <MenuItem value={20}>{'調査中／点検中'}</MenuItem>
              <MenuItem value={30}>{'調査済／点検済'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'確認中'}</MenuItem>
              <MenuItem value={60}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="rerportWait" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="rerportWait"
                  name="rerportWait"
                  component={renderCheckbox}
                  label="報告待ち"
                  onChange={this._handleChangeCheckbox}
                  // checked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid> */}
        </Grid>
        }
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.state.title === transitionListReport[1].gmnName &&
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>報告</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        }
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={ this.state.title === transitionListReport[1].gmnName ? transitionListReport : transitionList} />
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
            direction={'row'}
          >
            {this.renderTable()}
          </Grid>
        </MainContainer>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

